import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-tracking';
import { Mediator } from '@spotahome/soyuz-mediator';

import Feature from '../Feature';
import InstantBookingLabelCircledIcon from '../../icons/InstantBookingLabelCircledIcon';
import { INSTANT_BOOKING_FEATURE } from '../featureList';
import { CHANNELS } from '../../utils/constants';

import styles from '../ValuePropositionFeatures.module.scss';

const InstantBookingFeature = ({ onCollapsedChange, collapsed }) => {
  const handleIBModalOpen = e => {
    e.preventDefault();
    Metrics.hotjar.triggerEvent('listing-IB-modal-click');
    Mediator.publish(CHANNELS.OPEN_INSTANT_BOOKING_MODAL);
  };

  const renderBody = () => (
    <div
      role="button"
      tabIndex={-1}
      className={`${styles['instant-booking__body']} ga-instant-booking-ru-conditions`}
      onClick={handleIBModalOpen}
      dangerouslySetInnerHTML={{
        __html: trans('property_show.book_now_card.instant_booking.body')
      }}
    />
  );

  return (
    <Feature
      collapsed={collapsed}
      onCollapsedChange={onCollapsedChange}
      featureName={INSTANT_BOOKING_FEATURE}
      renderBody={renderBody}
      renderIcon={() => <InstantBookingLabelCircledIcon />}
      headerKey="property_show.book_now_card.instant_booking"
    />
  );
};

InstantBookingFeature.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onCollapsedChange: PropTypes.func.isRequired
};

export default InstantBookingFeature;
